const s = "_root_1sn7b_1", n = "_menuList_1sn7b_6", t = "_subMenu_1sn7b_12", o = {
  root: s,
  menuList: n,
  subMenu: t
};
export {
  o as default,
  n as menuList,
  s as root,
  t as subMenu
};
//# sourceMappingURL=index.es2495.js.map
